export const findData = (array, source, target) => {
  const existData = array?.find((data) => {
    return data[source] == target;
  });
  return existData;
};
